import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyStateMessage: {
		id: 'issue-archival-archives.archives-table.empty-state.empty-state-message',
		defaultMessage: 'We couldn’t find what you’re looking for',
		description: 'Message shown when there are no issues in the archives table',
	},
	emptyStateMessagePartTwo: {
		id: 'issue-archival-archives.archives-table.empty-state.empty-state-message-part-two',
		defaultMessage: 'Try using different search terms or filters.',
		description: 'Message shown when there are no issues in the archives table',
	},
	emptyStateNoDataMessage: {
		id: 'issue-archival-archives.archives-table.empty-state.empty-state-no-data-message',
		defaultMessage: 'There are no archived issues',
		description: 'Message shown when there are no archived issues in the project',
	},
	emptyStateNoDataDescriptionMessage: {
		id: 'issue-archival-archives.archives-table.empty-state.empty-state-no-data-description-message',
		defaultMessage: 'Any archived issues in your project will appear here.',
		description: 'Message shown when there are no archived issues in the project as description',
	},
	emptyStateArchiveIssueSupportMessage: {
		id: 'issue-archival-archives.archives-table.empty-state.empty-state-archive-issue-support-message',
		defaultMessage: 'More about archiving issues',
		description: 'Message shown to render the support document link of archived issues',
	},
	clearSearchMessage: {
		id: 'issue-archival-archives.archives-table.empty-state.clear-search-message',
		defaultMessage: 'Clear search',
		description:
			'Message shown on a button when there are no issues in the archives table and filter is applied',
	},
});
